import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import {UVT_MATERIAS_BY_TOPIC_ID} from "../Source/Materias";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import {blueGrey} from "@material-ui/core/colors";
import List from "@material-ui/core/List";
import {ListItem, ListItemAvatar, ListItemText} from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({

    root: {
        color: blueGrey[800],
    },
    inline: {
        display: "inline"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: '500',
    },
    semestre: {
        padding: '25px 0'
    },
    section: {
        padding: '20px 0'
    },
    subSection: {
        padding: '20px 0'
    },
    accordionHeader: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '80%',
        flexShrink: 0,
    },
    list: {
        width: '100%'
    }
}));

const listFeeder = [
    {title: "Qué son las funciones?", author: "Miguel Ramírez", content: "No entiendo muy bien cuál es la aplicación de las funciones en nuestra vida diaria"},
    {title: "Re: Qué son las funciones?", author: "Profesor", content: "Se pueden usar de mil maneras diferentes, por ejemplo, tú ganas $1,000.00 a la semana, y quieres saber cuánto dinero recibirás en 15 semanas. Es una función lineal, y = mx + b, donde m = $1,000, x = el número de semanas, b es el dinero que tienes en el banco en este momento y y, el dinero que tendrás"},
    {title: "Re: Re: Qué son las funciones?", author: "Miguel Ramírez", content: "Muchas gracias!"},
]

export default function Foro(props) {
    const classes = useStyles();
    return (
        <>
            <Typography variant="h2">
                Foro de Discusión
            </Typography>
            {UVT_MATERIAS_BY_TOPIC_ID["FB-392104"].temas.map(o => {
                return (
                    <div className={classes.section}>
                        <div className={classes.subSection}>
                            <Typography variant="h6" gutterBottom>
                                {o.descripcion}
                            </Typography>
                            <Typography>
                                {o.objetivo}
                            </Typography>
                        </div>
                        {o.subtemas.map(a => {
                            return (
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        // id={o.topicId}
                                    >
                                        <Typography
                                            className={classes.accordionHeader}>{a.subtema}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <List className={classes.list}>
                                            {listFeeder.map(o => (
                                                <>
                                                    <ListItem alignItems="flex-start">
                                                        <ListItemAvatar>
                                                            <Avatar alt={o.author} src="/static/images/avatar/1.jpg"/>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={o.title}
                                                            secondary={
                                                                <React.Fragment>
                                                                    <Typography
                                                                        component="span"
                                                                        variant="body2"
                                                                        className={classes.inline}
                                                                        color="textPrimary"
                                                                    >
                                                                        {o.title}
                                                                    </Typography>
                                                                    {"   "}{o.content}
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </ListItem>
                                                    <Divider variant="inset" component="li"/>
                                                </>
                                            ))}
                                        </List>
                                    </AccordionDetails>
                                </Accordion>
                            );
                        })}
                    </div>
                );
            })}
        </>
    );
}